import { OnsiteLocationSession } from './video';
import { ChatRoomStatus } from './common';
import { ChannelAuthMethod } from './common';

// From connection/socket.ts

export interface Message {
	message: any;
	type: string;
	data?: any;
}

export interface ConnectedUser {
	first_name: string;
	last_name: string;
	email: string;
	title: string;
	avatar: string;
	gr_user: number;
	// Added for migration strategy media+notes, but everything should be using gr_user moving forward
	brandlive_profile?: number;
	webrtcID?: string | number;
	screenShareWebrtcId?: string | number;
	socketId?: string;
	isProducer: boolean;
	videoMuted?: boolean;
	audioMuted?: boolean;
	location?: string;
	session: string;
	poster?: string | null;
	in_room?: boolean;
	restrictedUserState?: number;
	watcher_only?: boolean;
	selectedShowbuilderShot?: number | null;
	last_modified?: Date;
	feedWebRTCIds?: string[];
	companionMode?: boolean;
	onsiteLocationSession?: OnsiteLocationSession | null;
	shotModalId?: number | null;
	reconnectFrom?: string; // the socket id of the stale connection
	timingLeader?: boolean;
}

export interface ChatMess {
	gr_user: number;
	message: string;
	attachment?: string;
}

// From connection/chat.ts

export interface MessagesSeenResult {
	id: number;
	updateType: ChatRoomStatus;
	changedRows: number;
}

// From connection/auth.ts

export interface PresenterAllowed {
	auth_required: string;
    allowed: boolean;
}

export interface PresenterCreationReturn {
    token: string;
    app_signed_in_with: string;
    verified: boolean;
}

export interface CreatePlatformAccountResponse {
	status: number | null;
	success: boolean;
}

// From connection/scheduled-streams.ts

interface ScheduledStreamBase {
	id: number;
    createdByUser: number;
    updatedByUser: number;
    meetingId: number;
	status: ScheduledStreamStatus;
}

// Handle incoming UTC date strings from the API
export interface ScheduledStreamResponse extends ScheduledStreamBase {
    startTime: string;
    createdDate: string;
    updatedDate: string;
}

export enum ScheduledStreamStatus {
	None = 'none',
	Scheduled = 'scheduled',
    Prewarm = 'prewarm',
    Starting = 'starting',
	Started = 'started',
	Ended = 'ended',
}

// Convert to local timezone JS Date objects
export interface ScheduledStream extends ScheduledStreamBase {
    startTime: Date;
    createdDate: Date;
    updatedDate: Date;
}

export interface ScheduledStreamValidation {
    shotId: number;
    isValid: boolean;
    message: string;
}

// From connection/app-entry.ts

export interface UpdateInvitationResponse {
	invitationCode: string;
	isWatcherOnly: boolean | null;
	authType: ChannelAuthMethod | null;
}
